export * from './tokens-demo.component';
